module.exports = __webpack_public_path__ + "img/instagram.ee20bc91.png";